import { SVGProps } from 'react';
import { ReactComponent } from 'icons/rocket.svg';

type Props = SVGProps<SVGSVGElement>;

/**
 * @deprecated Move to storybook instead
 */
export const RocketIcon = (props: Props) => (
  <ReactComponent {...props} className="merc-icon-rocket" />
);
